/**
 * The language a new book starts in when nobody chose one: the user's interface language
 * if the brand offers books in it, otherwise the brand's first book language.
 *
 * The api writes it when a request names no language, the site preselects it in the
 * wizard: one copy of the rule for both. It matters because `Book.language` has no
 * default: an insert that forgot the language used to get Russian silently, which is
 * exactly right for one deployment and exactly wrong for the other.
 */
export function defaultBookLanguage(brand, locale) {
    return brand.bookLanguages.find((language) => language === locale) ?? brand.bookLanguages[0];
}
//# sourceMappingURL=book-language.js.map